import { REFERENCE_RECORD } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { CustomObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { toDSFieldRecord } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import formatProperties from 'reference-resolvers/formatters/formatProperties';
export class CustomObjectPropertiesAdapterConfig extends HttpAdapterConfig {
  getCacheKey(assetFamily) {
    return `OBJECT_PROPERTIES_${assetFamily}`;
  }
  isAssetFamilySupported(assetFamily) {
    return CustomObjectTypeIdRegex.test(assetFamily);
  }
  fetchData(httpClient, assetFamily) {
    const options = {
      query: {
        portalId: PortalIdParser.get(),
        includeFieldLevelPermission: true,
        includeProperties: true
      }
    };
    return httpClient(`properties/v4/groups/${assetFamily}`, options);
  }
  formatData(response, assetFamily) {
    const formattedProperties = formatProperties(response.results);
    // @ts-expect-error `toDSFieldRecord` not fully typed
    return toDSFieldRecord(formattedProperties, assetFamily, REFERENCE_RECORD);
  }
}
export default Adapter.makeFromConfig(CustomObjectPropertiesAdapterConfig);